enum DEVICE {
    MOBILE = 'MOBILE',
    TABLET = 'TABLET',
    DESKTOP = 'DESKTOP',
    APP_SHELL = 'APP_SHELL',
    IOS_APP_SHELL = 'IOS_APP_SHELL',
    ANDROID_APP_SHELL = 'ANDROID_APP_SHELL',
    NON_APP_SHELL = 'NON_APP_SHELL',
}


export { DEVICE };

